import React from 'react';

import styled from 'styled-components';

import aampeTheme from '../../../constants/aampeTheme';

import { createShouldForwardProp } from 'helpers/shouldForwardProp';

//hooks
import useAnalytics from '../../../hooks/helper/useAnalytics';
import useBreakpoint from '../../../hooks/helper/useBreakpoint';

// components
import CompactTab, { CompactTabItem } from './CompactTab';

interface CompactTabStyledProps {
    spreadTabs?: boolean;
}
const shouldForwardProps = createShouldForwardProp(['spreadTabs']);

export interface CompactTabMenuProps {
    activeTabKey: string;
    onTabClick: (value: string) => void;
    tabs: CompactTabItem[];
    action?: React.ReactNode;
    tabMenuStyling?: React.CSSProperties;
    spreadTabs?: boolean;
    tabStyling?: (
        isActive: boolean,
        tabsCount: number,
        breakpoint: string | undefined,
    ) => React.CSSProperties;
    refocusGrid?: () => void;
}

const CompactTabMenu: React.FC<React.PropsWithChildren<CompactTabMenuProps>> =
    ({
        activeTabKey,
        onTabClick,
        tabs,
        spreadTabs,
        action,
        tabMenuStyling,
        tabStyling,
        refocusGrid,
    }) => {
        const { track } = useAnalytics();
        const handleClick = (key: string) => {
            onTabClick(key);
            refocusGrid?.();
            try {
                track?.(`tab_toggled_from_${activeTabKey}_to_${key}`);
            } catch (err) {
                console.warn('Track failed in CompactTabMenu:', err);
            }
        };
        const { breakpoint } = useBreakpoint();
        return (
            <Container
                spreadTabs={spreadTabs}
                style={tabMenuStyling}
                role="tab-menu"
            >
                <TabBar spreadTabs={spreadTabs}>
                    {tabs.map((item) => (
                        <React.Fragment key={item.key}>
                            <CompactTab
                                tabItem={item}
                                isActive={activeTabKey === item.key}
                                onClick={() => handleClick(item.key)}
                                tabStyle={
                                    tabStyling
                                        ? tabStyling(
                                              activeTabKey === item.key,
                                              tabs.length,
                                              breakpoint,
                                          )
                                        : undefined
                                }
                            />
                        </React.Fragment>
                    ))}
                </TabBar>
                {action}
            </Container>
        );
    };

const Container = styled('div').withConfig({
    shouldForwardProp: shouldForwardProps,
})<CompactTabStyledProps>`
    padding: ${(props) =>
        props.spreadTabs
            ? aampeTheme.spacing4(0, 4, 0)
            : aampeTheme.spacing4(0)};
`;

const TabBar = styled('div').withConfig({
    shouldForwardProp: shouldForwardProps,
})<CompactTabStyledProps>`
    display: flex;
    justify-content: ${(props) =>
        props.spreadTabs ? 'space-between' : 'none'};
};`;

export default CompactTabMenu;
